import React, { useState, useEffect } from 'react';
import Header from "../../components/Header";
import { useLocation } from 'react-router-dom';
import Footer from "../../components/Footer";
import "../../styles/select-plan.scss";
import CTAButton from "../../components/LandingPage/Common/CTAButton";
import { refreshToken } from "../../api/identity/refreshToken";
import Cookies from 'js-cookie';
import Loader from '../../components/Loader';
import { jwtDecode } from 'jwt-decode';
import { sendAnalyticsEvent } from '../../utils/SendAnalyticsEvent';

function PurchaseFailed() {
    document.title = "iWantTFC - Discover | Purchase Failed";
    const [displayMessage, setDisplayMessage] = useState(false);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const message = queryParams.get('message');
    const error = queryParams.get('error');

    useEffect(() => {
        if (message?.toLowerCase()?.indexOf("session expired") >= 0 || error?.toLowerCase()?.indexOf("session expired") >= 0) {
            if (localStorage && localStorage.getItem('refreshToken')) {
                const _auc = Cookies.get('UserAuthentication');
                if (_auc) {
                    var jwt = jwtDecode(_auc);
                    const fetchData = async () => {
                        const refReq = {
                            token: localStorage.getItem('refreshToken'),
                            country: jwt.cp?.replace("ABSCBN-", "")
                        };
                        const refRes = await refreshToken(refReq);
                        if (refRes.isError) {
                            window.top.location.replace(process.env.REACT_APP_AUTH_LOGOUT_URL + "?redirectUrl=" + encodeURIComponent(window.location.origin + "/discover/select-plan"));
                        } else {
                            if (refRes.data.accessToken) {
                                Cookies.set("UserAuthentication", refRes.data.accessToken, { expires: 365, secure: true });
                                window.top.location.replace(window.location.origin + "/discover/select-plan");
                            } else {
                                window.top.location.replace(process.env.REACT_APP_AUTH_LOGOUT_URL + "?redirectUrl=" + encodeURIComponent(window.location.origin + "/discover/select-plan"));
                            }
                        }
                    }
                    fetchData();
                } else {
                    window.top.location.replace(process.env.REACT_APP_AUTH_LOGOUT_URL + "?redirectUrl=" + encodeURIComponent(window.location.origin + "/discover/select-plan"));
                }
            } else {
                window.top.location.replace(process.env.REACT_APP_AUTH_LOGOUT_URL + "?redirectUrl=" + encodeURIComponent(window.location.origin + "/discover/select-plan"));
            }
        } else {
            setDisplayMessage(true);
        }
    }, [error, message]);

    useEffect(() => {
        const eventProperties = {
            changePlanFailedReason: message ?? error
        };
        sendAnalyticsEvent("changePlanFailedRender", eventProperties, "Purchase Journey", "Discover page");
    }, []);

    return (
        <div>
            {
                displayMessage &&
                <div className="body" style={{ backgroundImage: 'url(' + process.env.PUBLIC_URL + '/images/footer-bg.png)' }}>
                    <Header />
                    <div className="ec-container purchase">
                        <div className="text-container">
                            <img alt="failed icon" src={process.env.PUBLIC_URL + '/images/icons/icon-failed.svg'} />
                            <p className="text-center">Transaction Failed!</p>
                        </div>
                        {
                            !message && !error &&
                            <p className="label margin-bottom-10">Your transaction has failed.</p>
                        }
                        {
                            (message || error) &&
                            <p className="label">Your transaction has failed due to</p>
                        }
                        {
                            message &&
                            <p className="pm">{message},</p>
                        }
                        {
                            error &&
                            <p className="pm">{error},</p>
                        }
                        <p className="label">Please try again.</p>
                        <CTAButton link="/select-plan" text="Try Again" eventName="changePlanTryAgainClick" />
                    </div>
                    <Footer bg="false" />
                </div>
            }
            {
                !displayMessage && <Loader />
            }
        </div>
    );
}

export default PurchaseFailed;